import {remote} from '../constants/environment';
import {defaultHeaders} from './headers';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {IFeeInvoiceCandidateListResponse} from '../interfaces/services';
import IInvoiceFeeSummary from '../interfaces/dtos/invoice-fee-summary.interface';

export const getInvoiceFeeCandidates = async (
  token: string,
): Promise<IFeeInvoiceCandidateListResponse> => {
  const remoteURI = remote.getInvoiceFeeCandidates();

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;

          return {
            success,
            payload: data.payload as IInvoiceFeeSummary[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IFeeInvoiceCandidateListResponse;
};
